import { Box, TableSortLabel, FormControl, Select, MenuItem, Menu, Typography, Slider } from '@mui/material';
import CustomAmountFilter from './customAmountFilter';
import CustomDatePicker from './CustomDatePicker';
import Iconify from '../components/Iconify';
import { useState } from 'react';

const CustomHeaderCell = ({
    className = 'table_header_cell_filterDesign',
    onColumnWidthChange,
    label,
    columnKey,
    sortBy,
    handleSort,
    sortable,
    isFilter,
    value,
    onChange,
    options,
    isFixed,
    columnWidth,
    fixSide = 'left',
    rightLabel = false,
    fixSidePosition = 0,
}) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const selectStyles = {
        '&:before': {
            borderBottom: '1px solid #EA5E00',
        },
        '&:after': {
            borderBottom: '2px solid #EA5E00',
        },
        '&:hover:not(.Mui-disabled):before': {
            borderBottom: '2px solid #EA5E00',
        },
        minWidth: 'auto',
        '& .MuiSelect-icon': {
            color: '#EA5E00',
            top: '50%',
            transform: 'translateY(-50%)',
        },
    };

    const handleOpenSlider = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseSlider = () => {
        setAnchorEl(null);
    };

    function valuetext(value) {
        return `${value}px`;
    }

    return (
        <Box
            className={className}
            sx={{
                minWidth: columnWidth?.[columnKey],
                maxWidth: columnWidth?.[columnKey],
                position: isFixed ? 'sticky' : 'relative',
                zIndex: isFixed ? 4 : 2,
                fixDirection: 0,
                ...(isFixed && { [fixSide]: fixSidePosition }),
            }}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: rightLabel ? 'flex-end' : '', gap: '10px' }}>
                    {label && (
                        <Box
                            sx={{
                                width: '24px',
                                height: '24px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Iconify
                                icon="ix:width"
                                sx={{ cursor: 'pointer', fontSize: '18px' }}
                                onClick={handleOpenSlider}
                            />
                        </Box>
                    )}
                    <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleCloseSlider}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                    >
                        <Box sx={{ width: '300px', padding: '20px' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                <Typography id="discrete-slider" gutterBottom>
                                    modifier la largeur de la colonne
                                </Typography>
                                <Slider
                                    onChange={(e, value) => onColumnWidthChange(value, columnKey)}
                                    defaultValue={columnWidth?.[columnKey]}
                                    getAriaValueText={valuetext}
                                    aria-labelledby="discrete-slider"
                                    valueLabelDisplay="auto"
                                    step={10}
                                    marks
                                    min={100}
                                    max={800}
                                    sx={{ color: '#EA5E00' }}
                                />
                            </Box>
                        </Box>
                    </Menu>
                    {sortable ? (
                        <TableSortLabel
                            active={sortBy?.[columnKey] !== null}
                            direction={sortBy?.[columnKey] || 'asc'}
                            hideSortIcon={sortBy?.[columnKey] === null}
                            sx={{
                                '&.MuiTableSortLabel-root': {
                                    cursor: 'auto',
                                    color: '#EA5E00',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    '&:hover': {
                                        color: '#EA5E00',
                                    },
                                    '&.Mui-active': {
                                        color: '#EA5E00',
                                    },
                                },
                            }}
                        >
                            <Typography sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {label}
                            </Typography>
                        </TableSortLabel>
                    ) : (
                        <span
                            style={{
                                color: '#EA5E00',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {label}
                        </span>
                    )}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        {sortable && (
                            <Iconify
                                icon="ic:round-sort-by-alpha"
                                sx={{ cursor: 'pointer', fontSize: '18px' }}
                                onClick={() => handleSort(columnKey)}
                            />
                        )}
                    </Box>
                </Box>
                {isFilter ? (
                    options === 'date' ? (
                        <CustomDatePicker value={value} onChange={onChange} fromTable={true} />
                    ) :
                        options === 'number' ? (
                            <CustomAmountFilter value={value} onChange={onChange} fromTable={true} />
                        ) : (
                            <FormControl fullWidth variant="standard">
                                <Select
                                    value={value}
                                    onChange={onChange}
                                    displayEmpty
                                    sx={selectStyles}
                                    renderValue={
                                        (selected) =>
                                            selected?.name ? selected.name : selected ? selected : 'Tous'
                                    }
                                >
                                    <MenuItem value="">Tous</MenuItem>
                                    {options?.map((option, index) => (
                                        <MenuItem key={index} value={option}>
                                            {option.name ?? option}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )
                ) : (
                    <Box sx={{ height: '30px' }} />
                )}
            </Box >
        </Box >
    );
};

export default CustomHeaderCell;